import React from 'react';
import Constants from './shared/constants';
import { Admin, Resource, fetchUtils } from 'react-admin';
import { MyUserList, MyUserCreate } from './components/my-users';
import { UserTypeList, UserTypeCreate } from './components/user-types';
import { NewList, NewEdit, NewCreate, NewShow } from './components/news';
import { PayprizeList, PayprizeEdit, PayprizeCreate, PayprizeShow } from './components/payprize';
import { PayprizeHomeList, PayprizeHomeEdit, PayprizeHomeCreate, PayprizeHomeShow } from './components/homepayprize';
import { SliderList, SliderEdit, SliderCreate, SliderShow } from './components/sliders';
import { FaqList, FaqEdit, FaqCreate, FaqShow } from './components/faqs';
import { TermsList, TermsEdit, TermsCreate, TermsShow } from './components/terminos_condiciones';
import { PqrList, PqrEdit, PqrCreate, PqrShow } from './components/pqrs';
import { ApqrsList, ApqrsEdit, ApqrsCreate, ApqrsShow } from './components/apqrs';
import { PageList, PageEdit, PageCreate, PageShow } from './components/pages';
import { SubPageList, SubPageEdit, SubPageCreate, SubPageShow } from './components/sub-pages';
import { CardList, CardEdit, CardCreate, CardShow } from './components/cards';
import { CartList, CartEdit, CartCreate, CartShow } from './components/carts';
import { QuestionList, QuestionEdit, QuestionCreate, QuestionShow } from './components/questions';
import { ServicesQualifyList, ServicesQualifyEdit, ServicesQualifyCreate, ServicesQualifyShow } from './components/services-qualifies';
import { ASQList, ASQEdit, ASQCreate, ASQShow } from './components/a-service-qualifies';
import { VistaCupones, ListaCupones, EditarCupones } from './components/cupones';
import { CrearCupones, VistaCuponesCrear } from './components/crear_cupones';
import { ListaCuponesReporte } from './components/reportes_cupones_descuento';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import authClient from './services/authClient';
import { Route } from 'react-router-dom';
import { ContadorRegresivo, CrearContadorRegresivo, NewShowConteoRegresivo, NewListConteoRegresivo, NewEditConteoRegresivo, NewCreateConteoRegresivo } from './components/contador_regresivo';
import { DeleteButton } from 'react-admin';


// Icons
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import BookIcon from '@mui/icons-material/Book';
import GroupIcon from '@mui/icons-material/Group';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DescriptionIcon from '@mui/icons-material/Description';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

import Login from './components/Login';
import MyLogoutButton from './components/Login/MyLogoutButton';
import CustomMenu from './components/Global/Layout/CustomMenu';
import ApiRestClient from './restClient';
import Dashboard from './components/dashboard';
import constants from './shared/constants';

import simpleRestProvider from 'ra-data-simple-rest';
import { createTheme, alpha } from '@mui/material/styles';
import { cyan, grey, blueGrey } from '@mui/material/colors';
import spanishMessages from 'ra-language-spanish';
import { decrypt } from './services/security/encryptorHandlerSecurity';
import UserHelper from './helpers/UserHelper';
import MyLayout from './components/Global/Layout';
import { getAuthApp } from './services/security/authApp';
import loopbackRestClient from 'aor-loopback';
const messages = {
    es: spanishMessages,
};

const darkBlack = '#000000';
const white = '#FFFFFF';
const fullBlack = '#000000';

const validateToken = async (user) => {
    if (user) {
        const urlGet = `${Constants.general.serverURL}/api/my-users/${user.userId}/accessTokens`;
        return await fetch(urlGet, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': getAuthApp() }
        })
            .then(response => {                
                if (!response.ok) { return false }
                return response.json();
            }).then(data => {                
                if (data.id || data[0].id)
                    if (data.id === user.id || data[0].id === user.id)
                        return true;
                return false;
            });
    }
    return false;
}
const httpClient = async (url, options = {}) => {    
    if (!options.method) {
        options.method = 'GET';   }

    
    if (options.method === 'GET' && options.body) {
        delete options.body;
    }    
    const v = UserHelper.validateLocal();

    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    
    options.headers.set('Authorization', getAuthApp());

    const user = typeof v === 'string' && v !== null ? JSON.parse(decrypt(localStorage.getItem(v))) : null;
    let v2 = await validateToken(user);

    if (v2) {
        let idt = '&access_token=' + user.id;
        let params = new URL(url);       
        if (params.searchParams.toString() !== '') {
            return fetchUtils.fetchJson(url + idt, options);
        }        
        return fetchUtils.fetchJson(url + '?' + idt, options);
    }

    return localStorage.clear();
}

const myTheme = createTheme({
    spacing: 8,
    typography: {
        fontFamily: 'Montserrat-medium',
    },
    palette: {
        primary: {
            main: '#27509b',
            dark: cyan[700],
            light: grey[400],
        },
        secondary: {
            main: blueGrey[700],
            light: grey[100],
            dark: grey[500],
        },
        text: {
            primary: darkBlack,
            secondary: darkBlack,
        },
        background: {
            default: white,
            paper: white,
        },
        divider: grey[400],
        action: {
            disabled: alpha(darkBlack, 0.3),
        },
        tonalOffset: 0.2,
        pickerHeaderColor: cyan[500],
        clockCircleColor: alpha(darkBlack, 0.07),
        shadowColor: fullBlack,
    },
});

const App = () => (
    <Admin
        loginPage={Login}
        logoutButton={MyLogoutButton}
        menu={CustomMenu}
        authProvider={authClient}
        locale="es"
        messages={messages}
        dashboard={Dashboard}
        appLayout={MyLayout}
        theme={myTheme}        
        dataProvider={ApiRestClient(loopbackRestClient(`${constants.general.serverURL}/api`, httpClient))}
        title="LotiColombia"
    >
        <Resource name="news" options={{ label: 'Noticias' }} show={NewShow} list={NewList} edit={NewEdit} create={NewCreate} icon={ReceiptIcon} />
        <Resource name="sliders" options={{ label: 'Sliders' }} show={SliderShow} list={SliderList} edit={SliderEdit} create={SliderCreate} icon={PhotoLibraryIcon} />
        <Resource name="pages" options={{ label: 'Páginas' }} list={PageList} edit={PageEdit} create={PageCreate} show={PageShow} icon={InsertDriveFileIcon} />
        <Resource name="SubPages" options={{ label: 'Subpáginas' }} list={SubPageList} edit={SubPageEdit} create={SubPageCreate} show={SubPageShow} icon={DescriptionIcon} />
        <Resource name="Cards" options={{ label: 'Tarjetas' }} list={CardList} edit={CardEdit} create={CardCreate} show={CardShow} icon={DescriptionIcon} />
        <Resource name="faqs" initSection options={{ label: 'FAQS' }} list={FaqList} create={FaqCreate} edit={FaqEdit} show={FaqShow} icon={SpeakerNotesIcon} />
        <Resource name="terminos_condiciones" initSection options={{ label: 'Politicas de Privacidad' }} list={TermsList} create={TermsCreate} edit={TermsEdit} show={TermsShow} icon={DescriptionIcon} />
        <Resource name="pqrs" initSection options={{ label: 'PQR' }} list={PqrList} create={PqrCreate} edit={PqrEdit} show={PqrShow} icon={ContactMailIcon} />
        <Resource name="apqrs" initSection options={{ label: 'Respuestas PQR' }} list={ApqrsList} show={ApqrsShow} icon={ContactMailIcon} />
        <Resource name="cupones" options={{ label: 'Cupones' }} list={ListaCupones} show={VistaCupones} edit = {EditarCupones} icon={CardGiftcardIcon} />  
        <Resource name="crear_cupones" options={{ label: 'Crear Cupones' }}  show= {VistaCuponesCrear} create = {CrearCupones} list={CrearCupones} icon={CardGiftcardIcon} />
        <Resource name="reportes_cupones_descuento" options={{ label: 'Reportes Cupones'}} list={ListaCuponesReporte} icon={CardGiftcardIcon} />
        <Resource name="my-users" options={{ label: 'Usuarios' }} create={MyUserCreate} list={MyUserList} edit={MyUserCreate} icon={GroupIcon} />
        <Resource name="user-types" options={{ label: 'Tipos de Usuario' }} list={UserTypeList} create={UserTypeCreate} icon={LibraryAddIcon} />        
        <Resource name="payprize" options={{ label: 'Reclamar Premios' }} list={PayprizeList} create={PayprizeCreate} edit={PayprizeEdit} show={PayprizeShow} icon={MonetizationOnIcon} />
        <Resource name="homepayprize" options={{ label: 'Informativa Home' }} list={PayprizeHomeList} create={PayprizeHomeCreate} edit={PayprizeHomeEdit} show={PayprizeHomeShow} icon={MonetizationOnIcon} />
        <Resource name="Carts" options={{ label: 'Carrito de compras' }} list={CartList} edit={CartEdit} create={CartCreate} show={CartShow} icon={ShoppingCartIcon} />
        <Resource name="questions" options={{ label: 'Preguntas' }} list={QuestionList} create={QuestionCreate} edit={QuestionEdit} show={QuestionShow} icon={FeedbackIcon} />
        <Resource name="services-qualifies" options={{ label: 'Calificación de Servicios' }} list={ServicesQualifyList} create={ServicesQualifyCreate} edit={ServicesQualifyEdit} show={ServicesQualifyShow} icon={QuestionAnswerIcon} />
        <Resource name="a-services-qualifies" options={{ label: 'Calificación de Servicios Avanzada' }} list={ASQList} show={ASQShow} icon={QuestionAnswerIcon} />
        <Resource name="conteoregresivo" options={{ label: 'Contador Regresivo' }} parentCategorie="cupones_descuento" show={NewShowConteoRegresivo} list={NewListConteoRegresivo} edit={NewEditConteoRegresivo} create={NewCreateConteoRegresivo} remove={DeleteButton} icon={ReceiptIcon } />

    </Admin>
);

export default App;
